var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.543 28.5C6.81217 28.5 0.542969 22.2308 0.542969 14.5C0.542969 6.7692 6.81217 0.5 14.543 0.5C22.2738 0.5 28.543 6.7692 28.543 14.5C28.543 22.2308 22.2738 28.5 14.543 28.5Z",
    fill: "url(#paint0_linear_401_1101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5436 6.6656C17.0944 6.6656 17.3968 6.674 18.4048 6.7216C19.3372 6.7636 19.844 6.9204 20.18 7.052C20.6252 7.2256 20.9444 7.4328 21.2776 7.766C21.6108 8.0992 21.818 8.4184 21.9916 8.8636C22.1232 9.1996 22.2772 9.7064 22.322 10.6388C22.3668 11.6468 22.378 11.9492 22.378 14.5C22.378 17.0508 22.3696 17.3532 22.322 18.3612C22.28 19.2936 22.1232 19.8004 21.9916 20.1364C21.818 20.5816 21.6108 20.9008 21.2776 21.234C20.9444 21.5672 20.6252 21.7744 20.18 21.948C19.844 22.0796 19.3372 22.2336 18.4048 22.2784C17.3968 22.3232 17.0944 22.3344 14.5436 22.3344C11.9928 22.3344 11.6904 22.326 10.6824 22.2784C9.74998 22.2364 9.24318 22.0796 8.90718 21.948C8.46198 21.7744 8.14277 21.5672 7.80957 21.234C7.47637 20.9008 7.26917 20.5816 7.09557 20.1364C6.96397 19.8004 6.80997 19.2936 6.76517 18.3612C6.72037 17.3532 6.70917 17.0508 6.70917 14.5C6.70917 11.9492 6.71757 11.6468 6.76517 10.6388C6.80717 9.7064 6.96397 9.1996 7.09557 8.8636C7.26917 8.4184 7.47637 8.0992 7.80957 7.766C8.14277 7.4328 8.46198 7.2256 8.90718 7.052C9.24318 6.9204 9.74998 6.7664 10.6824 6.7216C11.6904 6.674 11.9928 6.6656 14.5436 6.6656ZM14.5436 4.9436C11.948 4.9436 11.6232 4.9548 10.604 5.0024C9.58757 5.05 8.89317 5.2096 8.28277 5.4476C7.65557 5.6884 7.12077 6.016 6.59157 6.548C6.05957 7.08 5.73478 7.612 5.48838 8.242C5.25318 8.8496 5.09077 9.544 5.04317 10.5632C4.99557 11.5824 4.98438 11.9072 4.98438 14.5028C4.98438 17.0984 4.99557 17.4232 5.04317 18.4424C5.09077 19.4588 5.25038 20.1532 5.48838 20.7636C5.73198 21.388 6.05957 21.9228 6.59157 22.452C7.12357 22.984 7.65557 23.3088 8.28557 23.5552C8.89317 23.7904 9.58757 23.9528 10.6068 24.0004C11.626 24.048 11.9508 24.0592 14.5464 24.0592C17.142 24.0592 17.4668 24.048 18.486 24.0004C19.5024 23.9528 20.1968 23.7932 20.8072 23.5552C21.4316 23.3116 21.9664 22.984 22.4956 22.452C23.0276 21.92 23.3524 21.388 23.5988 20.758C23.834 20.1504 23.9964 19.456 24.044 18.4368C24.0916 17.4176 24.1028 17.0928 24.1028 14.4972C24.1028 11.9016 24.0916 11.5768 24.044 10.5576C23.9964 9.5412 23.8368 8.8468 23.5988 8.2364C23.3552 7.612 23.0276 7.0772 22.4956 6.548C21.9636 6.016 21.4316 5.6912 20.8016 5.4448C20.194 5.2096 19.4996 5.0472 18.4804 4.9996C17.464 4.9548 17.1392 4.9436 14.5436 4.9436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5432 9.59155C11.8328 9.59155 9.63477 11.7896 9.63477 14.5C9.63477 17.2104 11.8328 19.4084 14.5432 19.4084C17.2536 19.4084 19.4516 17.2104 19.4516 14.5C19.4516 11.7896 17.2536 9.59155 14.5432 9.59155ZM14.5432 17.6864C12.7848 17.6864 11.3568 16.2612 11.3568 14.5C11.3568 12.7388 12.7848 11.3136 14.5432 11.3136C16.3016 11.3136 17.7296 12.7388 17.7296 14.5C17.7296 16.2612 16.3016 17.6864 14.5432 17.6864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.646 10.5464C20.2801 10.5464 20.794 10.0324 20.794 9.39837C20.794 8.76434 20.2801 8.25037 19.646 8.25037C19.012 8.25037 18.498 8.76434 18.498 9.39837C18.498 10.0324 19.012 10.5464 19.646 10.5464Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_1101",
    x1: 4.64347,
    y1: 24.3995,
    x2: 24.4425,
    y2: 4.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0551048,
    stopColor: "#FFD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    stopColor: "#FEC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2004,
    stopColor: "#FCA71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#FA8316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    stopColor: "#F85510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#F51E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F30005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    stopColor: "#F20007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    stopColor: "#E1003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    stopColor: "#D30067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    stopColor: "#C70088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8589,
    stopColor: "#BF00A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9357,
    stopColor: "#BB00AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_1101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.542969 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.90fea3a7d50323d290b77e55674cfb94.svg";
export { ForwardRef as ReactComponent };